const DropdownIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.3 7.7L0.3 1.7C0.1 1.5 -5.68248e-08 1.3 -4.37114e-08 1C-3.0598e-08 0.699999 0.1 0.499999 0.3 0.299999C0.7 -0.100001 1.3 -0.100001 1.7 0.3L7 5.6L12.3 0.3C12.7 -0.1 13.3 -0.1 13.7 0.3C14.1 0.7 14.1 1.3 13.7 1.7L7.7 7.7C7.3 8.1 6.7 8.1 6.3 7.7Z"
        fill="#5E5E5E"
      />
    </svg>
  );
};

export default DropdownIcon;
